import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import customIcons from './icons/index.js'

Vue.use(Vuetify)

export default new Vuetify({
  rtl: false,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#000',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#E83550',
        danger: '#E02D48',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        'subtitle-gray': '#666',
        gray: '#666',
        'gray-2': '#F2F2F2',
        white: '#fff',
        link: '#8E64AA',
        neutral: '#999',
        indigo: '#5E47B7',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
    values: customIcons,
  },
})
